import { restoreTenderDefinition } from "@snubes/snubes-types";
import { getCallable } from "../../Firebase/helpers/getCallable";

export const restoreTenderCallable = getCallable(restoreTenderDefinition);
